/**
 * authors: Patrick Vyn Badiang and Sean Fleming
 */
import { Box, Typography } from "@mui/material";
import "../../App.css";

//Global Variables
import { useDirection } from "../../UtilityFunctions";

function AboutPage({activeSection}) {

  const isActive = activeSection === "about";
  const direction = useDirection();
    return (
      <div className={`animate__animated ${
        isActive ? "animate__fadeIn" : "animate__backOutUp"
          }`} 
          style={{
            opacity: isActive ? 1 : 0,
            visibility: isActive ? "visible" : "hidden",
            transition: "opacity 0.2s ease, visibility 0.2s ease",
          }}
          >
        <div className="entire-block-page">
      
        {direction === "horizontal" ? (
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", width: "100%", height: "100%", margin:"20px"}}>
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start", alignContent: "start",width: "80%" , mb: "20px", height: "100%"}}>
                <Typography variant="h3" sx={{fontSize: "2.6rem", paddingTop: "3rem"}} color="primary" align="center">
                  Future APIDA Leaders of tomorrow within business.
                </Typography>
            </Box>

            <Box sx={{ p: 3,  width: "100%", borderColor: "primary.main", backgroundColor: "rgba(22, 22, 22, 1)"}}>

              <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "start", width: "100%"}}>
                {/* Bullet 1 */}
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "start"}}>
                  <Box sx={{width: "19%"}}/>
                  <Box sx={{display: "flex", flexDirection: "column", justifyContent: direction === "horizontal" ? "start" : "center", alignItems: "start"}}>
                      <Typography variant="body" sx={{fontSize: { xs: "2.5rem", sm: "2.7rem", md: "2.9rem", lg: "3rem" }}} color="primary" align= {direction === "horizontal" ? "inherit" : "center"}>
                          Innovative</Typography>
                      <Typography variant="body1" color="primary" align="inherit" sx={{ width: direction === "horizontal" ? "75%": "90%", fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1.1rem", lg: "1.25rem" } }}>
                      We aspire to promote professional development, and build a community that celebrates diversity and inclusion. 
                      </Typography>
                  </Box>
                </Box>

                <Box sx={{ height: "20px" }} />
                {/* Bullet 2 */}
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "start"}}>
                  <Box sx={{width: "19%"}}/>
                  <Box sx={{display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start"}}>
                      <Typography variant="body" sx={{fontSize: { xs: "2.5rem", sm: "2.7rem", md: "2.9rem", lg: "3rem" }}} color="primary" align= {direction === "horizontal" ? "inherit" : "center"}>
                        Professional</Typography>
                      <Typography variant="body1" color="primary" align="inherit" sx={{ width: direction === "horizontal" ? "75%": "90%", fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1.1rem", lg: "1.25rem" } }}>
                      Through mentorship, networking, and collaboration, we aim to create opportunities for personal and career growth. 
                      </Typography>
                  </Box>
                </Box>
                
                <Box sx={{ height: "20px" }} />
                {/* Bullet 3 */}
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "start"}}>
                  <Box sx={{width: "12%"}}/>
                  <Box sx={{display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start"}}>
                      <Typography variant="body" sx={{fontSize: { xs: "2.5rem", sm: "2.7rem", md: "2.9rem", lg: "3rem" }}} color="primary" align= {direction === "horizontal" ? "inherit" : "center"}>
                        Social</Typography>
                      <Typography variant="body1" color="primary" align="inherit" sx={{ width: direction === "horizontal" ? "75%": "90%", fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1.1rem", lg: "1.25rem" } }}>
                      While also supporting our members to achieve excellence in business environments.
                      </Typography>
                  </Box>
                </Box>
            </Box>
            </Box>
            
            

            <Box sx ={{width: "100%",  display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
              <img className="animate__animated animate__bounce" src="/img_images/Profiles/Group_Profile.png" alt="Group" style={{height: "auto", maxWidth: "100%", imageRendering: "pixelated"}}/>    
              {/* <img className="animate__animated animate__bounce" src="/img_images/blank.png" style={{height: "auto", width: "15%"}}/>
              <img className="animate__animated animate__bounce" src="/img_images/blank.png" style={{height: "auto", width: "33.33%"}}/>        */}
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", width: "100%", height: "100%", margin:"20px"}}>
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start", alignContent: "start",width: "80%" , mb: "20px", height: "100%"}}>
                <Typography variant="h3" sx={{fontSize: "2.6rem", paddingTop: "3rem"}} color="primary" align="center">
                  Future APIDA Leaders of tomorrow within business.
                </Typography>
            </Box>

            <Box sx={{ p: 3,  width: "100%", borderColor: "primary.main", backgroundColor: "rgba(22, 22, 22, 1)"}}>

              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start", width: "100%"}}>
                {/* Bullet 1 */}
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "start"}}>
                  <Box sx={{width: "19%"}}/>
                  <Box sx={{display: "flex", flexDirection: "column", justifyContent: direction === "horizontal" ? "start" : "center", alignItems: "start"}}>
                      <Typography variant="body" sx={{fontSize: { xs: "2.5rem", sm: "2.7rem", md: "2.9rem", lg: "3rem" }}} color="primary" align= {direction === "horizontal" ? "inherit" : "center"}>
                          Innovative</Typography>
                      <Typography variant="body1" color="primary" align="inherit" sx={{ width: direction === "horizontal" ? "75%": "90%", fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1.1rem", lg: "1.25rem" } }}>
                      We aspire to promote professional development, and build a community that celebrates diversity and inclusion. 
                      </Typography>
                  </Box>
                </Box>

                <Box sx={{ height: "20px" }} />
                {/* Bullet 2 */}
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "start"}}>
                  <Box sx={{width: "19%"}}/>
                  <Box sx={{display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start"}}>
                      <Typography variant="body" sx={{fontSize: { xs: "2.5rem", sm: "2.7rem", md: "2.9rem", lg: "3rem" }}} color="primary" align= {direction === "horizontal" ? "inherit" : "center"}>
                        Professional</Typography>
                      <Typography variant="body1" color="primary" align="inherit" sx={{ width: direction === "horizontal" ? "75%": "90%", fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1.1rem", lg: "1.25rem" } }}>
                      Through mentorship, networking, and collaboration, we aim to create opportunities for personal and career growth. 
                      </Typography>
                  </Box>
                </Box>
                
                <Box sx={{ height: "20px" }} />
                {/* Bullet 3 */}
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "start"}}>
                  <Box sx={{width: "12%"}}/>
                  <Box sx={{display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start"}}>
                      <Typography variant="body" sx={{fontSize: { xs: "2.5rem", sm: "2.7rem", md: "2.9rem", lg: "3rem" }}} color="primary" align= {direction === "horizontal" ? "inherit" : "center"}>
                        Social</Typography>
                      <Typography variant="body1" color="primary" align="inherit" sx={{ width: direction === "horizontal" ? "75%": "90%", fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1.1rem", lg: "1.25rem" } }}>
                      While also supporting our members to achieve excellence in business environments.
                      </Typography>
                  </Box>
                </Box>
            </Box>
            </Box>
            
            

            <Box sx ={{width: "100%",  display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
              <img className="animate__animated animate__bounce" src="/img_images/Profiles/Group_Profile.png" alt="Group" style={{height: "auto", maxWidth: "100%", imageRendering: "pixelated"}}/>    
              {/* <img className="animate__animated animate__bounce" src="/img_images/blank.png" style={{height: "auto", width: "15%"}}/>
              <img className="animate__animated animate__bounce" src="/img_images/blank.png" style={{height: "auto", width: "33.33%"}}/>        */}
            </Box>
          </Box>
        )}
      
      

      </div>
    </div>
    );
}

export default AboutPage;

